export default __webpack_public_path__ + "static/media/chevron-left.42ebf3a8.svg";